export const makeConstantFactory = (prefix) => (constant) => `@@app/${prefix}/${constant}`



// WEBPACK FOOTER //
// ./src/scripts/utils/constantsHelper.js